import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HomeIcon from '@mui/icons-material/Home';

const ContactCompletePage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 8, textAlign: 'center' }}>
      <Box>
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />
        <Typography variant="h1" component="h1" sx={{ mt: 2, mb: 2 }}>
          送信完了
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          お問い合わせありがとうございました。<br />確認のうえ、改めてご連絡させていただきます。
        </Typography>
        <Box display="flex" justifyContent="center" gap={2}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<HomeIcon />}
            onClick={() => navigate('/')}
          >
            トップページへ戻る
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ContactCompletePage;
